import { render, staticRenderFns } from "./FormChangeMetaDataWorkbook.vue?vue&type=template&id=119dae7a&scoped=true&lang=pug"
import script from "./FormChangeMetaDataWorkbook.vue?vue&type=script&lang=js"
export * from "./FormChangeMetaDataWorkbook.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetaDataWorkbook.vue?vue&type=style&index=0&id=119dae7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119dae7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119dae7a')) {
      api.createRecord('119dae7a', component.options)
    } else {
      api.reload('119dae7a', component.options)
    }
    module.hot.accept("./FormChangeMetaDataWorkbook.vue?vue&type=template&id=119dae7a&scoped=true&lang=pug", function () {
      api.rerender('119dae7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormChangeMetaDataWorkbook.vue"
export default component.exports